import { useCallback, useEffect } from 'react';
import { useLazyWebhookInfoIntegrationWebhookInfoGetQuery } from '@shared/api';

export const useGetIntegrationInfo = (integrationId: number, enabled: boolean = true) => {
  const [trigger, { data, isLoading, isFetching, isError, reset }] =
    useLazyWebhookInfoIntegrationWebhookInfoGetQuery();

  const refetch = useCallback(() => {
    if (!integrationId) return;

    trigger({ webhookIntegrationId: integrationId }, false);
  }, [integrationId, trigger]);

  useEffect(() => {
    if (!enabled) {
      reset();
      return;
    }

    refetch();
  }, [enabled, refetch, reset]);

  return {
    integrationInfo: data,
    isEmpty: !data,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};
